import { useState } from 'react';

import { Tabs, Column, ResponsiveOverlay } from 'components/Blocks';

import { MainTaskData } from './MainData';
import { TaskLogs } from './Logs';
import { TaskRecruitment } from './Recruitment';
import { TaskCosts } from './TaskCost';

import { TaskHeader } from './Header';
import { TaskAlerts } from './Alerts';
import { LoadingTaskModal } from './Loading';

import { useTaskModal, withTaskModalContext } from './context.taskModal';

export interface TaskModalProps {
  children?: never;
  id: string;
  open: boolean;
  close: () => void;
}

const tabs = {
  main: MainTaskData,
  logs: TaskLogs,
  costs: TaskCosts,
  recruitment: TaskRecruitment,
};

function TaskModalBase() {
  const [tab, setTab] = useState('main');

  const { loading, task, close, isOpen } = useTaskModal();

  if (!isOpen) return null;

  const Component = tabs[tab as keyof typeof tabs];

  return (
    <ResponsiveOverlay
      close={close}
      isOpen={isOpen}
      width="min(90vw, 760px)"
      className="h-[90vh] max-w-full overflow-y-auto phone:h-[80vh]"
      preventOpenAutoFocus
      allowEscape
    >
      <Column>
        {loading ? (
          <LoadingTaskModal />
        ) : (
          <>
            <TaskHeader />

            <TaskAlerts />

            <Tabs
              value={tab}
              onTabChange={setTab}
              tabs={[
                { value: 'main', getLabel: (t) => t('main') },
                { value: 'logs', getLabel: (t) => t('activity-log') },
                { value: 'costs', getLabel: (t) => t('costs') },
                {
                  value: 'recruitment',
                  getLabel: (t) => t('recruitment'),
                  hide: !task?.hasRecruitment,
                },
              ]}
            />

            <Component />
          </>
        )}
      </Column>
    </ResponsiveOverlay>
  );
}

export const TaskModal = withTaskModalContext(TaskModalBase);
